import React, { useEffect, useCallback, useRef } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import {
  useGlobalLogin,
  parkOffScreen,
  clearInlinePosition,
} from '../../providers/GlobalLoginProvider';
import useStyles from './index.style';

const SignInModal = ({
  closeModal,
  setLoginModal,
  open,
  setLiteProfileLoading,
  setTriggerGuestProfile,
  children,
  setGuestName = () => {},
}) => {
  const css = useStyles();
  const {
    signInOpen,
    openSignIn,
    closeSignIn,
    globalLoginContainer,
    loadingLiteProfile,
    claimDialog,
    releaseDialog,
  } = useGlobalLogin();
  const prevOpenRef = useRef(open);

  useEffect(() => {
    claimDialog();
    return () => releaseDialog();
  }, [claimDialog, releaseDialog]);

  useEffect(() => {
    if (open) {
      openSignIn({
        onSuccess: () => closeModal(),
        onLiteProfileLoaded: ({ loyaltyData }) => {
          setLiteProfileLoading(false);
          setLoginModal(false);
          setTriggerGuestProfile(true);
          setGuestName(loyaltyData);
        },
      });
    } else if (prevOpenRef.current) {
      closeSignIn();
    }
    prevOpenRef.current = open;
  }, [open]);

  const dialogOpen = open || signInOpen;

  const handleClose = () => {
    closeSignIn();
    closeModal();
  };

  const dialogContentRef = useCallback(
    (node) => {
      if (node && dialogOpen && globalLoginContainer) {
        clearInlinePosition(globalLoginContainer);
        node.appendChild(globalLoginContainer);
      }
    },
    [dialogOpen, globalLoginContainer],
  );

  useEffect(() => {
    if (!dialogOpen && globalLoginContainer && globalLoginContainer.parentNode !== document.body) {
      parkOffScreen(globalLoginContainer);
    }
  }, [dialogOpen, globalLoginContainer]);

  useEffect(() => {
    if (loadingLiteProfile) {
      setLiteProfileLoading(loadingLiteProfile);
    }
  }, [loadingLiteProfile]);

  return (
    <Dialog
      onClose={handleClose}
      open={dialogOpen}
      scroll="body"
      closeAfterTransition
      maxWidth="md"
      classes={{ paper: css.paper }}>
      <DialogContent dividers={false} className={css.MuiDialogContentRoot} ref={dialogContentRef}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

SignInModal.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  setLoginModal: PropTypes.func,
  setLiteProfileLoading: PropTypes.func,
  setTriggerGuestProfile: PropTypes.func,
  setGuestName: PropTypes.func,
  children: PropTypes.element,
};

export default SignInModal;
